<div class="flex-grow-1 flex-fill text-sm-right text-left small" *ngIf="importHistory">
  {{ 'dashboard.updatedDate' | translate: { date: importHistory.date } }}
  <br />
  <span *ngIf="importHistory?.userEmail">{{ 'dashboard.updatedAuteur' | translate: { email: importHistory.userEmail } }}</span>
</div>
